import { border, boxShadow, color, compose, display, flexbox, grid, height, maxHeight, maxWidth, minHeight, minWidth, overflow, position, shadow, space, system, typography, verticalAlign, width, } from "styled-system";
import css from "@styled-system/css";
const cursor = system({
    cursor: true,
});
const whiteSpace = system({
    whiteSpace: true,
});
export const includeStyledSystem = () => compose(border, boxShadow, color, display, flexbox, grid, height, maxHeight, maxWidth, minHeight, minWidth, overflow, position, shadow, space, typography, verticalAlign, width, cursor, whiteSpace);
export const sx = (props) => css(props.sx);
